import { render, staticRenderFns } from "./editBlock.vue?vue&type=template&id=0c5bdba4"
import script from "./editBlock.vue?vue&type=script&lang=js"
export * from "./editBlock.vue?vue&type=script&lang=js"
import style0 from "./editBlock.vue?vue&type=style&index=0&id=0c5bdba4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports